module.exports = __webpack_public_path__ + "images/6b50063ade757a1847f3a5575860b1c0-PLAYA-DEL-CARMEN-WHITE.png";